import axios from 'axiosConfig';

export const getAllLoanInfo = () => axios.post("/api/reports/loaninfo", {});

export const getSupplementData = (params) => axios.post("/api/supplements/supplementdata", params);

export const getPortfolioAnalysisDetail = (params) =>
    axios.post("/api/supplements/portfolioanalysisdetail", params, { responseType: 'blob' });

export const getLoanServicingWorksheet1 = (params) =>
    axios.post("/api/supplements/loanservicingworksheet1", params, { responseType: 'blob' });

export const getLoanServicingWorksheet2 = (params) =>
    axios.post("/api/supplements/loanservicingworksheet2", params, { responseType: 'blob' });

export const getAllCity = () => axios.get("/api/reports/city", {});

export const getLoanOfficers = () => axios.get("/api/reports/loanofficer", {});

export const getFundSource = () => axios.get("/api/reports/fundsource", {});

export const getAllCounty = () => axios.get("/api/reports/county", {});

export const getAllLoanStatus = () => axios.post("/api/users/loanstatus", {});
